import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const FormulaBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M1 11.6667C1 12.0203 1.14048 12.3594 1.39052 12.6095C1.64057 12.8595 1.97971 13 2.33333 13C3.66667 13 3.66667 10.3333 4.33333 7C5 3.66667 5 1 6.33333 1C6.68696 1 7.02609 1.14048 7.27614 1.39052C7.52619 1.64057 7.66667 1.97971 7.66667 2.33333M2.33333 7H6.33333M9 7L13 11M9 11L13 7" 
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconContainer>
);